import { Component } from "@angular/core";
import { FloorplanReferenceMeasureMenuComponent } from "@project/floorplanner/floorplan-menu/fgds/dimensions-menu/floorplan-reference-measure-menu/floorplan-reference-measure-menu.component";
import { FloorplanMeasurementLineMenuComponent } from "@project/floorplanner/floorplan-menu/fgds/dimensions-menu/measurement-line-menu/floorplan-measurement-line-menu.component";

@Component({
  selector: "app-floorplan-dimensions-menu",
  imports: [FloorplanMeasurementLineMenuComponent, FloorplanReferenceMeasureMenuComponent],
  templateUrl: "./floorplan-dimensions-menu.component.html",
  styleUrl: "./floorplan-dimensions-menu.component.scss",
  standalone: true,
})
export class FloorplanDimensionsMenuComponent {}
